export default __webpack_public_path__ + "static/media/pot3.2b219341.svg";